import React, {ReactElement} from 'react';
import {cx} from '@emotion/css';
import {useIntl} from 'react-intl';
import {RouteComponentProps} from '@reach/router';
import Layout from '../components/DesignSystem/Layout/GeneralLayout/GeneralLayout';
import SEO from '../components/seo';
import ErrorPageContainer from '../components/DesignSystem/ErrorPageContainer/ErrorPageContainer';
import {ErrorPageType} from '../components/DesignSystem/ErrorPageContainer/config';
import CentralCallout from '../components/DesignSystem/Layout/CentralCallout/CentralCallout';
import {isBrowser} from '../browserSupport';

import styles from './_errorPage.styles';

const NotFoundPage: React.ComponentType<RouteComponentProps> = (): ReactElement | null => {
  const {formatMessage} = useIntl();

  if (!isBrowser) {
    return null;
  }

  return (
    <Layout className={cx(styles.container)}>
      <SEO title={formatMessage({id: 'phoenix.page.title.404'})} />
      <CentralCallout>
        <ErrorPageContainer showLinks type={ErrorPageType.ERROR_404} />
      </CentralCallout>
    </Layout>
  );
};

export default NotFoundPage;
